import { createFeature, createReducer, on } from "@ngrx/store";
import { BasicLayoutState } from "../models/basic-layout-state.interface"
import { basicLayoutActions } from "./actions";

const initialBasicLayoutState: BasicLayoutState = {
    sidebarOpened: false,
    modalOpened: false,
    modalResourceUrl: null,
    modalResourceType: null,
};

export const basicLayoutFeature = createFeature({
    name: 'basicLayout',
    reducer: createReducer(
        initialBasicLayoutState,
        on(
            basicLayoutActions.setSidebarVisibility,
            (state, action): BasicLayoutState => ({
                ...state,
                sidebarOpened: action.opened
            })
        ),
        on(
            basicLayoutActions.openResourceInModal,
            (state, action): BasicLayoutState => ({
                ...state,
                sidebarOpened: false,
                modalOpened: true,
                modalResourceUrl: action.resourceUrl,
                modalResourceType: action.resourceType
            })
        ),
        on(
            basicLayoutActions.closeModal,
            (state, action): BasicLayoutState => ({
                ...state,
                modalOpened: false,
                modalResourceUrl: null,
                modalResourceType: null
            })
        )
    )
});